const credentials =
  process.env.MIX_SIMPLYRETS_API_KEY +
  ':' +
  process.env.MIX_SIMPLYRETS_API_SECRET;

export const getMapListings = () => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(
        'https://api.simplyrets.com/properties?type=residential&maxprice=2000000&limit=500',
        {
          crossDomain: true,
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Basic ' + btoa(credentials),
          },
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch(() =>
        reject('We are having trouble getting the property listings.')
      );
  });
};

export const getCommunityListings = (route, community) => {
  function getMaxprice(route) {
    switch (route) {
      case 'ascaya':
        return '10000000';
      case 'anthem-cntry-club':
      case 'centennial-hills':
      case 'dragon-ridge-country-club':
      case 'macdonald-highlands':
      case 'red-rock-cntry-club':
      case 'tournament-hills':
        return '5000000';
      default:
        return '2500000';
    }
  }

  const maxprice = getMaxprice(route);
  const url = `https://api.simplyrets.com/properties?type=residential&maxprice=${maxprice}&limit=500&sort=-listprice`;

  return new Promise((resolve, reject) => {
    window.axios
      .get(url, {
        params: {
          q: community,
        },
        crossDomain: true,
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Basic ' + btoa(credentials),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch(() =>
        reject('We are having trouble getting the property listings.')
      );
  });
};

export const getListing = (mlsId) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`https://api.simplyrets.com/properties/${mlsId}`, {
        crossDomain: true,
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Basic ' + btoa(credentials),
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch(() =>
        reject('We are having trouble getting the property listing.')
      );
  });
};
